export default __webpack_public_path__ + "static/media/shape1.3c0c67f9.svg";